import React from "react";
import "./SocialLogos.css";

const SocialLogos = () => {
  return (
    <div id="social-logos">
      <div className="social-i">
        <a href="https://discord.com/invite/amxq49sr7n" target={"_blank"}>
          <i className="bi bi-discord icon-discord"></i>
        </a>
      </div>

      <div className="social-i">
        <a href="https://mobile.twitter.com/kung_fu_koalas" target="_blank">
          <i className="bi bi-twitter icon-twitter"></i>
        </a>
      </div>

      <div className="social-i">
        <a href="https://www.instagram.com/kungfu_koalas/?hl=en" target={"_blank"}>
          <i className="bi bi-instagram icon-instagram"></i>
        </a>
      </div>

      <div className="social-i">
        <a href="https://kungfukoalas.com/" target={"_blank"}>
          <i className="bi bi-globe2 icon-web"></i>
        </a>
      </div>
    </div>
  );
};

export default SocialLogos;
